import { render } from "./tabUserList.vue?vue&type=template&id=379fd5e0&scoped=true"
import script from "./tabUserList.vue?vue&type=script&lang=js"
export * from "./tabUserList.vue?vue&type=script&lang=js"

import "./tabUserList.vue?vue&type=style&index=0&id=379fd5e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379fd5e0"]])